import React from "react";
import "./blog.scss";
import blog1 from "../../Assets/images/blog/main-blog1.png";
import blog2 from "../../Assets/images/blog/main-blog2.png";
import {Link} from "react-router-dom";


const blogCards = [
    {
        title: "Healthy Vegetables Salads to Try",
        text:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione, aperiam! Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
        badge: "Vegetables",
        img:blog1
    },
    {
        title: "Baked Dishes That’s Worth Trying",
        text:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione, aperiam! Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
        badge: "Vegetables",
        img:blog2
    }
]

const Blog = () => {
  return (
    <section className="section blog">
      <div className="container">
          <h1 className="text-center">Our Blogs</h1>
        <div className="row my-5">
          {
              blogCards.map(card =>(
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" data-aos="fade-up">
                <div className="card" >
                  <img src={card.img} className="card-img-top" alt={card.title} />
                  <div className="card-body">
                    <h6 className="card-title"><i className="far fa-user fa-1x"></i> Admin <span class="badge bg-success text-white">{card.badge}</span></h6>
                    <h5 className="card-title">{card.title}</h5>
                    <p className="card-text">
                      {card.text}
                    </p>
                    <Link to="/blogs">
                      Read more <span><i style={{marginLeft :"5px"}} className="fas fa-long-arrow-alt-right fa-1x"></i></span>
                    </Link>
                  </div>
                </div>
              </div>
              ))
              }
        </div>
      </div>
    </section>
  );
        }

export default Blog;
